export default __webpack_public_path__ + "static/media/profile-bleble.48435dd2.png";